import React, {useEffect, useState} from "react"
import {AccountFeatures, AppContext} from "@lightspeed-invoicing/core-client/frontend"
import {FormattedMessage, injectIntl} from "react-intl"
import SideBar from "../../common/layout/sidebar.component.jsx"
import LoadingSpinner from "../../common/spinner/loading.component.jsx"
import SalesToolsTabs from "../../common/layout/tabs/salestools.component.jsx"
import Toggle from "react-toggle"
import PriceLevelSelect from "../../product/price-level/PriceLevelSelect"
import DefaultOptionService from "../../state/default-option/DefaultOptionService"
import AccountService from "../../state/account/service"
import {PROPOSAL_OPTION_KEY} from "../../state/proposal/ProposalOptionKey"
import { useDispatch } from "react-redux"
import { fetchPriceLevels } from "../../state/price-level/PriceLevelActions"

const BottomPriceEdit = () => {

    const isFeatureEnabled = AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureBottomLinePrice)
    const [priceLevelId, setPriceLevelId] = useState<string>("")
    const [isBottomPriceEnabled, setIsBottomPriceEnabled] = useState<boolean>(isFeatureEnabled)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const dispatch = useDispatch()

    useEffect(() => {
        const controller = new AbortController()
        fetchBottomPriceLevelOption()
        dispatch(fetchPriceLevels())
        return () => controller.abort()
    }, [])

    const fetchBottomPriceLevelOption = () => {
        DefaultOptionService.fetchDefaultProposalOptionsByOptionKey(PROPOSAL_OPTION_KEY.BOTTOM_LINE_PRICE_LEVEL_ID)
            .then(defaultOption => {
                setPriceLevelId(defaultOption.getValue())
                setIsLoading(false)
            })
    }

    const disableBottomPriceFeature = () => {
        const payload = {
            features: [
                {
                    featureKey: AccountFeatures.FeatureBottomLinePrice,
                    enabled: !isBottomPriceEnabled
                }
            ]
        }
        AccountService.patch(payload).then(() => {
            setIsBottomPriceEnabled(!isBottomPriceEnabled)
        })
    }

    const updateDefaultPriceLevelOption = (selectedPriceLevelId) => {
        DefaultOptionService.updateDefaultProposalOptions(PROPOSAL_OPTION_KEY.BOTTOM_LINE_PRICE_LEVEL_ID, selectedPriceLevelId)
            .then(() => setPriceLevelId(selectedPriceLevelId))
    }

    if (isLoading) {
        return <LoadingSpinner/>
    }

    SideBar.activateMenu("sales-tools")

    return <div>
        <SalesToolsTabs/>
        <div className="row ui-has-modules py-1">
            <div className="col-12 ui-module">
                <div className="form-group row">
                    <label className="col-3 col-form-label text-align-right" htmlFor="bottomLineFormEditEnable">
                        <FormattedMessage
                            id="bottom_line.sections.BottomPriceEdit.enable"
                            defaultMessage="Enable Bottom Line button on the pricing table interface"
                        />
                    </label>
                    <div className="col-9 d-flex align-items-center">
                        <Toggle
                            id={"bottom-line"}
                            defaultChecked={isBottomPriceEnabled}
                            icons={false}
                            onChange={disableBottomPriceFeature}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label text-align-right" htmlFor="accountId">
                        <FormattedMessage
                            id="bottom_line.sections.BottomPriceEdit.price_level"
                            defaultMessage="Price level that represents your bottom line"
                        />
                    </label>
                    <div className="col-3">
                        <PriceLevelSelect
                            selectedPriceLevelId={priceLevelId}
                            onChange={updateDefaultPriceLevelOption}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default injectIntl(BottomPriceEdit)


// WEBPACK FOOTER //
// ./src/bottom-line/sections/BottomPriceEdit.tsx